var _rect, _path, _path2, _path3, _rect2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppConnectMorePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 9,
    width: 21,
    height: 30,
    rx: 4,
    fill: "#3451D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.5C16 24.2239 16.2239 24 16.5 24H17.5C17.7761 24 18 24.2239 18 24.5V31H16V24.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.5C20 19.2239 20.2239 19 20.5 19H21.5C21.7761 19 22 19.2239 22 19.5V31H20V19.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.5C24 22.2239 24.2239 22 24.5 22H25.5C25.7761 22 26 22.2239 26 22.5V31H24V22.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#6981EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2976 20.4279C42.6178 20.2332 42.6178 19.7683 42.2976 19.5736L36.103 15.806C35.7698 15.6034 35.3431 15.8432 35.3431 16.2332V18.0007H29C28.4477 18.0007 28 18.4485 28 19.0007V21.0007C28 21.553 28.4477 22.0007 29 22.0007H35.3431V23.7683C35.3431 24.1583 35.7698 24.3981 36.103 24.1955L42.2976 20.4279Z",
    fill: "#F56E76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7023 28.4279C27.3821 28.2332 27.3821 27.7683 27.7023 27.5736L33.897 23.806C34.2302 23.6034 34.6568 23.8432 34.6568 24.2332V26.0008H40.9999C41.5522 26.0008 41.9999 26.4485 41.9999 27.0008V29.0008C41.9999 29.553 41.5522 30.0008 40.9999 30.0008H34.6568V31.7683C34.6568 32.1583 34.2302 32.3981 33.897 32.1955L27.7023 28.4279Z",
    fill: "#42D0D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppConnectMorePage);
export default __webpack_public_path__ + "static/media/app-connect-more-page.a7a88f14634eadd5024f3270a491bd52.svg";
export { ForwardRef as ReactComponent };